<script lang="ts">
    import {getInjector} from 'src/core';
    import type {ButtonStyle, ComponentSize} from '../../ui-widgets/types';
    import type {ActionRequestMethod} from '../../constants';
    import {createEventDispatcher} from 'svelte';
    import {fade} from 'svelte/transition';
    import ActionRequestService from '../../services/action-request.service';
    import {actionRequestMethods, states} from '../../constants';
    import KpButton from '../../ui-widgets/button/KpButton.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';

    export let path: string;
    export let requestMethod: ActionRequestMethod = actionRequestMethods.GET;
    export let requestBody: Record<string, unknown> = {};
    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let isBlock = false;
    export let isDisabled = false;
    export let title = '';
    export let additionalClasses = '';
    export let id: string = null;
    export let noWrap = false;

    const dispatch = createEventDispatcher<{ success: void }>();
    const actionRequestService = getInjector().getByClass(ActionRequestService);
    const processingFadeAnimParams = {duration: 250};

    let state = states.INITIAL;

    async function performRequest(): Promise<void> {
        try {
            state = states.PROCESSING;
            await actionRequestService.action(path, requestMethod, requestBody);
            dispatch('success');
        } finally {
            state = states.NORMAL;
        }
    }
</script>

<KpButton {buttonStyle}
          {buttonSize}
          {isDisabled}
          {title}
          {isBlock}
          {noWrap}
          {id}
          additionalClasses="kp-action-request-button {additionalClasses}"
          on:click={performRequest}>

    {#if state === states.PROCESSING}
        <div class="processing-overlay" transition:fade={processingFadeAnimParams}>
            <KpLoadingBlock size="xs"/>
        </div>
    {/if}

    <slot/>
</KpButton>

<style lang="less">
    :global {
        .kp-action-request-button {
            position: relative;
        }
    }

    .processing-overlay {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, 0.5);
    }
</style>